import axios from 'axios';

const authApiCreator = (baseAuthPath) => {
  return {
    resetPassword(params) {
      const { password, passwordConfirmation } = params;
      return axios.put(`${baseAuthPath}/password`, {
        password,
        password_confirmation: passwordConfirmation,
      });
    },
    updatePassword(params) {
      const { currentPassword, password, passwordConfirmation } = params;
      return axios.put(`${baseAuthPath}/password`, {
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      });
    },
    loginUser(params) {
      const { uid, password } = params;
      return axios.post(`${baseAuthPath}/sign_in`, {
        uid: uid.toLowerCase(),
        password,
      });
    },
    validateToken() {
      return axios.get(`${baseAuthPath}/validate_token`);
    },
    logoutUser() {
      return axios.delete(`${baseAuthPath}/sign_out`);
    },
    resetPasswordRequest(params) {
      const { uid } = params;
      return axios.post(`${baseAuthPath}/password`, {
        uid: uid.toLowerCase(),
        email: uid.toLowerCase(),
        redirect_url: '',
      });
    },
    signUpRequest(params) {
      const { uid } = params;
      return axios.post(`${baseAuthPath}/confirmation`, {
        uid: uid.toLowerCase(),
        email: uid.toLowerCase(),
        redirect_url: '',
      });
    },
  };
};

export default authApiCreator;
